import * as STD from '@emersya/mpa-std';
import * as CM from '@emersya/mpa-components-manager';
import * as BasketNS from '@emersya/mpa-basket';
import {
	Field,
	Text
} from '@emersya/mpa-components';

export interface IPlannerDimensionsEditorComponentConfiguration extends CM.DOMComponent.IConfiguration {
	readonly increment: number;
};

export class PlannerDimensionsEditorComponent extends CM.DOMComponent<
	HTMLDivElement,
	PlannerDimensionsEditorComponent,
	IPlannerDimensionsEditorComponentConfiguration
> {
	component_DOM: HTMLDivElement;

	async onDimensionUpdated(event: STD.events.Event<any, CM.Component<any, any>>) {
		await app.sequential(async () => {
			if (!app.basket || !app.basket.basket.currentProduct) {
				return;
			}
			await app.basket.basket.usePartReference(
				app.basket.basket.currentProduct.id,
				['dimensions', event.target.component_parent.id],
				event.details.newValue
			);
		});
	};

	async onBasketPartUpdated(event: STD.events.Event<any, CM.Component<any, any>>) {
		if (!event.details.part) {
			return;
		}
		const part = <BasketNS.Part>event.details.part;
		if (
			!part.reference ||
			part.parent?.id !== 'dimensions' ||
			!(part.parent instanceof BasketNS.Part) ||
			!(part.parent.parent instanceof BasketNS.Product)
		) {
			return;
		}
		await (<Field.Component>this.component_find(`@:${part.id}`)).updateValue(part.reference.value);
	};

	async reset() {
		const product = app.component_configuration.PMS.products.find(x => x.SKU === app.currentProductSKU);
		if (!product) {
			this.component_throwLibraryError('', {});
		}

		const fw = (<Field.Component>this.component_find('@:width'));
		const fd = (<Field.Component>this.component_find('@:depth'));
		const fh = (<Field.Component>this.component_find('@:height'));
		fw.input.value = -1;
		fd.input.value = -1;
		fh.input.value = -1;
		await fw.updateValue(product.dimensions.width.default);
		await fd.updateValue(product.dimensions.depth.default);
		await fh.updateValue(product.dimensions.height.default);
	};

	override async component_initialize() {
		await super.component_initialize();
		if (!app.basket) {
			this.component_throwLibraryError('', {});
		}
		for (const product of app.basket.basket.products) {
			await this.initializeProduct(product);
		}
		(<Text.Component>this.component_find('@:width:header.unit')).update('m');
		(<Text.Component>this.component_find('@:depth:header.unit')).update('m');
	};

	private async initializeProduct(product: BasketNS.Product) {
		const part = product.createPart({
			id: 'dimensions',
			title: 'Dimensions',
			reference: null,
			metaData: null,
			parts: [
				{
					id: 'width',
					title: 'Width',
					reference: BasketNS.Reference.deserialize({value: '0'}),
					options: [],
					metaData: null,
					parts: []
				}, {
					id: 'depth',
					title: 'Depth',
					reference: BasketNS.Reference.deserialize({value: '0'}),
					options: [],
					metaData: null,
					parts: []
				}, {
					id: 'height',
					title: 'Height',
					reference: BasketNS.Reference.deserialize({value: '0'}),
					options: [],
					metaData: null,
					parts: []
				}
			],
			options: []
		});
		await part.initialize();
	};

	private async onNewProduct(event: STD.events.Event<any, CM.Component<any, any>>) {
		const product = event.details.product;
		await this.initializeProduct(product);
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: IPlannerDimensionsEditorComponentConfiguration
	) {
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement>STD.DOM.factory({
			tag: 'div'
		});
		void this.onNewProduct;
	};
};
export namespace NS {
	export const Component = PlannerDimensionsEditorComponent;
	export type Component = PlannerDimensionsEditorComponent;
	export type Configuration = IPlannerDimensionsEditorComponentConfiguration;
}
import manifestXMLSource from './PlannerDimensionsEditor.xml';
import './PlannerDimensionsEditor.scss';

CM.Manager.declare({
	id: 'viewer-planner-dimensionsEditor',
	type: PlannerDimensionsEditorComponent,
	manifest: manifestXMLSource
});
